<template>
  <div style="overflow-y: hidden">
    <div class="landNavbar" id="fixed">
      <!-- brand design -->
      <div class="flexNav" id="landingLogo">
        <router-link
          :to="{
            name: 'Landingpage',
          }"
          class="flexLogo"
        >
          <img
            src="@/assets/landingLogo.svg"
            width="237"
            height="49"
            alt="main page logo"
          />
        </router-link>
      </div>

      <!-- profile design -->
      <div class="flexNav" id="navigation">
        <a class="landingButton" href="#contact">Contact Us</a>
        <!--:to="{
                name: 'Contact',
            }"-->
        <router-link
          class="landingButton"
          :to="{
            name: 'EmailLandingPage',
          }"
          >Schools</router-link
        >
        <router-link
          class="landingButton"
          :to="{
            name: 'Login',
          }"
          >Login</router-link
        >

        <router-link
          class="landingButton"
          :to="{
            name: 'Signup',
          }"
          >Sign up</router-link
        >
        <div class="hamburgerMenu">
          <input id="hamburgerBox" type="checkbox" />

          <span class="hamburgerLayer" id="firstLayer"></span>
          <span class="hamburgerLayer" id="secondLayer"></span>
          <span class="hamburgerLayer" id="thirdLayer"></span>

          <ul id="smallMenu">
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'EmailLandingPage',
              }"
              >Schools</router-link
            >
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Login',
              }"
              >Login</router-link
            >

            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Signup',
              }"
              >Sign up</router-link
            >

            <div id="contact" class="navbarBottom">
              <div class="totalContact contactLeft">
                <a
                  href="https://apps.apple.com/ca/app/courselnk/id1545799969"
                  class="appstore"
                  target="_blank"
                ></a>
                <a
                  href="https://facebook.com/courselnk"
                  class="facebook"
                  target="_blank"
                ></a>

                <a
                  href="https://instagram.com/courselnk"
                  class="instagram"
                  target="_blank"
                ></a>

                <a
                  href="https://linkedin.com/company/71220107"
                  class="linkedin"
                  target="_blank"
                ></a>
                <a
                  href="mailto:support@courselnk.com"
                  class="email"
                  target="_blank"
                ></a>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <div id="mainBody">
      <div class="boxed">
        <p class="bigText">Brand Ambassador</p>
        <p class="mediumText margin20">
          CourseLnk is a student-run, community oriented platform that seeks to
          connect students together in order to help them keep up with their
          classes.
        </p>
        <p class="mediumText margin20">
          Become a community builder and help your campus be a more inclusive
          and accessible place. Join a fast growing tech startup and develop
          your leadership skills!
        </p>
        <p class="mediumText margin20">As an ambassador you will:</p>
        <p class="mediumText margin20">
          - become the face of CourseLnk at your university!
        </p>
        <p class="mediumText margin20">
          - spread the word about our platform among your network!
        </p>
        <p class="mediumText margin20">
          - encourage students to get the best out of their university
          experience!
        </p>
      </div>
      <div class="boxed">
        <p class="bigText">What you need</p>
        <div class="infoBox">
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorOutgoing.svg" />
            <p class="mediumTitle margin20">Outgoing attitude</p>
            <p class="mediumText margin20">
              We are looking for outgoing, conscientious students that share our
              vision and are willing to spread the word about our platform.
            </p>
          </div>
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorSocial.svg" />
            <p class="mediumTitle margin20">Social media</p>
            <p class="mediumText margin20">
              Campus ambassadors must be willing to leverage their social media
              network in order to represent CourseLnk as effectively as
              possible.
            </p>
          </div>
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorSpirit.svg" />
            <p class="mediumTitle margin20">Entrepreneurial spirit</p>
            <p class="mediumText margin20">
              CourseLnk is a fast growing tech startup based out of Toronto,
              Ontario. We are looking for ambitious candidates with an interest
              in entrepreneurship.
            </p>
          </div>
        </div>
      </div>
      <div class="boxed">
        <p class="bigText">What you'll get</p>
        <div class="infoBox">
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorWork.svg" />
            <p class="mediumTitle margin20">Exclusive Access</p>
            <p class="mediumText margin20">
              As a CourseLnk ambassador, you will gain exclusive access to new
              features on the CourseLnk app. You will also have the opportunity
              to offer your direct input to our developers and be a part of
              shaping CourseLnk’s future.
            </p>
          </div>
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorMerch2.svg" />
            <p class="mediumTitle margin20">Cool Merch</p>
            <p class="mediumText margin20">
              Like merch? CourseLnk ambassadors will be sent cool merchandise
              including hoodies, t-shirts, and socks! The more users you get on
              our platform, the cooler the merch you receive.
            </p>
          </div>
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorPrize.svg" />
            <p class="mediumTitle margin20">Pay and Prizes</p>
            <p class="mediumText margin20">
              By attracting users, CourseLnk ambassadors become eligible for
              prize draws and special access to private events.
            </p>
          </div>
        </div>
        <div class="infoBox">
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorMerch.svg" />
            <p class="mediumTitle margin20">Valuable work experience</p>
            <p class="mediumText margin20">
              Gain valuable entrepreneurial and marketing experience with one of
              Canada’s most exciting young startups.
            </p>
          </div>
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorFlex.svg" />
            <p class="mediumTitle margin20">Jumpstart your career</p>
            <p class="mediumText margin20">
              We guarantee letters of recommendations for all ambassadors that
              hit their goals.
            </p>
          </div>
          <div class="rowBox">
            <img class="infoImages" src="@/assets/ambassadorJoin.svg" />
            <p class="mediumTitle margin20">Join the Movement</p>
            <p class="mediumText margin20">
              Become a student leader by making your university community more
              inclusive, accessible and fun.
            </p>
          </div>
        </div>
      </div>
      <div class="boxed">
        <p class="bigText">👋 We'd love to have you on our team!</p>
        <p class="mediumText margin20">
          But first, we'd like to know a bit about you.
        </p>
      </div>
      <form @submit.prevent="createAmbassador" id="ambassadorForm">
        <input
          v-model="name"
          required
          type="text"
          placeholder="First and last name"
          class="boxed smallInput"
        />
        <input
          v-model="email"
          required
          type="text"
          placeholder="Contact email"
          class="boxed smallInput"
        />
        <input
          v-model="university"
          required
          type="text"
          placeholder="What university you will be attending in the fall 2021"
          class="boxed smallInput"
        />
        <textarea
          v-model="q1"
          required
          type="text"
          placeholder="Describe your online presence (what social media are you on, how many followers do you have, how often do you post etc…). [~150 words]"
          class="boxed bigInput"
        />

        <textarea
          v-model="q2"
          required
          type="text"
          placeholder="What extracurriculars/initiatives could you leverage to attract new users? [~150 words]"
          class="boxed bigInput"
        />

        <textarea
          v-model="q3"
          required
          type="text"
          placeholder="If you had the opportunity, what would be the ideal marketing strategy for a university of your choice. [~200 words]"
          class="boxed bigInput"
        />

        <div class="centered">
          <p v-if="feedback" class="submitText">{{ feedback }}</p>
          <button type="submit" class="doneButton">Submit form</button>
          <label
            >* By submitting you agree to receive CourseLnk marketing materials
            such as Instagram, Facebook, and LinkedIn marketing materials to
            share on your own feed</label
          >
        </div>
      </form>
      s
    </div>
  </div>
</template>

<script>
import db from "@/db";
export default {
  name: "Signup",
  data: () => ({
    name: null,
    email: null,
    university: null,
    q1: null,
    q2: null,
    q3: null,
    feedback: null,
  }),

  methods: {
    resetForm() {
      this.name = null;
      this.email = null;
      this.university = null;
      this.q1 = null;
      this.q2 = null;
      this.q3 = null;
    },
    createAmbassador() {
      var re = /\S+@\S+\.\S+/;
      if (re.test(this.email)) {
        this.feedback = "Thank you for your submission!";
        this.email = this.email.toLowerCase();
        db.collection("ambassadors").add({
          name: this.name,
          email: this.email,
          university: this.university,
          onlinePresence: this.q1,
          inPersonPresence: this.q2,
          strategy: this.q3,
          createdAt: Date.now(),
        });
        this.resetForm();
      } else {
        this.feedback = "Please enter a valid email";
      }
    },
  },
};
</script>

<style scoped src="@/styles/views/Ambassadors.css"></style>
